import type { PeriodTimeline } from "../types/forecast";

export function emptyTimeline(): PeriodTimeline {
  return {
    axisStart: "06:00",
    axisEnd: "23:00",
    layout: "collapsed",
    hours: Array.from({ length: 18 }, (_, index) => {
      const hour = 6 + index;
      return {
        localTime: `${hour.toString().padStart(2, "0")}:00`,
        rainPopPct: null,
        snowPopPct: null,
        icePopPct: null,
        thunderPopPct: 0,
        windMph: null,
        gustMph: null,
      };
    }),
  };
}
